import { vysePoplatku } from 'helpers/contract/vysePoplatku';
import { Date, Money } from 'modules';
import React, { useMemo } from 'react';
import PlaceSignature from '../components/PlaceSignature';
import { bonatoCompany } from 'constants/company';

interface Content202301SpravaProps {
  contract: GQL.IContract;
  form: GQL.IContractOnlineForm;
  formData: any;
}

const Content202301Sprava = ({ contract, form, formData }: Content202301SpravaProps) => {
  const provozovna = useMemo(() => contract?.provozovna, [contract]);

  return (
    <>
      <div className="mb-3 text-center">
        <strong>OBJEDNÁVKA NA ODDLŽENIE BONATO č. {contract?.cislo}</strong>
      </div>

      <div className="mb-3">
        DODÁVATEĽ:
        <br />
        <strong>{bonatoCompany.name}</strong>
        <br />
        so sídlom {provozovna?.ulice}, {provozovna?.psc} {provozovna?.mesto}
        <br />
        korešpondenčná adresa <strong>{bonatoCompany.contactAddress}</strong>
        <br />
        IČO: {provozovna?.ico}, DIČ: {provozovna?.dic}
        <br />
        {provozovna?.zalozeno}
        <br />
        {bonatoCompany.ceo}, konateľ
      </div>

      <div className="mb-3">
        OBJEDNÁVATEĽ:
        <br />
        Meno a priezvisko:{' '}
        <strong>
          {contract?.prijmeni} {contract?.jmeno}
        </strong>
        <br />
        trvale bytom: {contract?.ulice} {contract?.cislo_popisne}, {contract?.mesto}, {contract?.psc}
        <br />
        dátum narodenia: {contract?.rc}
        <br />
        telefonický kontakt: {contract?.mobil}
        <br />
        e-mail: {contract?.email}
      </div>

      <div className="mb-2 text-center">
        <strong>I. PREDMET OBJEDNÁVKY:</strong>
      </div>
      <div className="mb-3">
        <div className="mb-2">Predmetom tejto objednávky je:</div>
        <div className="mb-2">Oddlženie BONATO obsahuje:</div>
        <ul>
          <li>Posúdenie jednotlivých finančných záväzkov.</li>
          <li>
            Návrh riešenia, ktoré z vyššie uvedených finančných záväzkov je vhodné vziať do správy záväzkov, a ktoré
            nie. Návrh, akým spôsobom sa objednávateľ za splnenia zákonných podmienok môže legálnym spôsobom zbaviť
            svojich dlhov a rozumne hospodáriť s vlastnými finančnými prostriedkami. (ďalej len „dielo").
          </li>
        </ul>
      </div>

      <div className="mb-2 text-center">
        <strong>II. DOBA REALIZÁCIE DIELA:</strong>
      </div>
      <div className="mb-3">
        <p className="paragraph">
          Dodávateľ sa zaväzuje odovzdať objednávateľovi dielo – návrh riešenia- správu o zhodnotení, ktoré z finančných
          záväzkov je vhodné vziať do správy záväzkov a ktoré nie a to do 7 pracovných dní od doručenia všetkých
          dokladov, ktoré dodávateľ od objednávateľa požadoval a zaplatenia odmeny. Objednávateľ sa zaväzuje poskytnúť
          dodávateľovi potrebnú súčinnosť nevyhnutnú na splnenie diela (doloženie dokladov, poskytnutie informácií) a
          berie na vedomie, že doba realizácie diela sa predlžuje o obdobie, počas ktorého bude dodávateľ čakať na
          súčinnosť objednávateľa. V prípade, že dodávateľ po zhodnotení ekonomicko-finančnej situácie a posúdení
          jednotlivých finančných záväzkov odporučí objednávateľovi uzatvoriť zmluvu o správe záväzkov, dodávateľ sa
          zaväzuje uzatvoriť s objednávateľom zmluvu o správe záväzkov bezodplatne.
        </p>
      </div>

      <div className="mb-2 text-center">
        <strong>III. ODMENA ZA SLUŽBY:</strong>
      </div>
      <div className="mb-3">
        <p className="paragraph">
          Dodávateľ a objednávateľ sa dohodli na odmene za vyššie uvedené služby{' '}
          <strong>
            vo výške <Money value={vysePoplatku(contract)} />
          </strong>
          .
        </p>
      </div>

      <div className="mb-2 text-center">
        <strong>IV. SPLATNOSŤ ODMENY:</strong>
      </div>
      <div className="mb-2">
        <p className="paragraph">
          Dodávateľ a objednávateľ sa dohodli, že :<br />
          ODMENA vo výške <Money value={vysePoplatku(contract)} /> je splatná{' '}
          <Date value={contract?.spravaDluhu?.prvni_platba_termin?.toString()} /> to prevodom na bankový účet
          dodávateľa.
        </p>
        {formData?.installments && formData?.installmentsPlan?.paymentsPlan?.length > 0 && (
          <>
            <p>
              Oddlžovací poradca dodávateľa sa môže s objednávateľom dohodnúť na úhrade a splatnosti odmeny v splátkach:
            </p>
            <ol style={{ margin: '5px 0 20px 16px' }}>
              {formData.installmentsPlan.paymentsPlan.map((payment: any, index: number) => (
                <li key={`payment-${index}`}>
                  <Money value={payment.payment} /> / <Date value={payment.date} />
                </li>
              ))}
            </ol>
          </>
        )}
      </div>
      <div className="mb-3">
        Bankový účet DODÁVALEĽA je vedený u Poštová banka, a.s.
        <br />
        <strong>SK49 8330 0000 0023 0266 1356</strong>,<br />
        variabilný symbol: <strong>{contract?.cislo}</strong>
        <br />
        špecifický symbol: <strong>{contract?.rc?.replace('/', '')}</strong>
      </div>

      <div className="mb-2 text-center">
        <strong>V. DÔLEŽITÉ UPOZORNENIE</strong>
      </div>
      <div className="mb-5">
        <p className="paragraph">
          Dodávateľ a objednávateľ sa dohodli, že vypracovaný návrh riešenia bude objednávateľovi odovzdaný v sekcii
          On-line dodávateľa po splnení vyššie uvedených podmienok a po uhradení odmeny v plnom rozsahu.
        </p>
        <p className="paragraph">
          Objednávateľ berie na vedomie, že pokiaľ nedôjde z jeho strany k prevzatiu návrhu riešenia na základe výzvy
          dodávateľa v sekcii On-line dodávateľ je oprávnený zaslať tento návrh riešenia na poskytnutú emailovú adresu,
          v prípade, ak objednávateľ nemá emailovú adresu, alebo ju neposkytol, dodávateľ je oprávnený zaslať tento
          návrh riešenia doporučene poštovou zásielkou na poskytnutú korešpondenčnú adresu objednávateľa.
        </p>
        <p className="paragraph">
          Objednávateľ a poverený pracovník dodávateľa sa môžu dohodnúť, akým spôsobom bude návrh riešenia
          objednávateľovi odovzdaný. Zo strany dodávateľa je objednávka splnená v plnom rozsahu odovzdaním návrhu
          riešenia v sekcii On-line dodávateľa alebo zaslaním návrhu riešenia na emailovú adresu alebo doporučene
          poštovou zásielkou na korešpondenčnú adresu.
        </p>
        <p className="paragraph">
          V prípade, ak sa Oddlžovací poradca dohodol s objednávateľom na úhrade a splatnosti úhrady odmeny v splátkach,
          a pokiaľ zo strany objednávateľa nedôjde k úhrade celej odmeny v zmysle tejto objednávky v stanovenom termíne,
          objednávateľ nemá nárok na odovzdanie diela a objednávka zanikne neuhradením odmeny v stanovenom termíne.
        </p>
      </div>
      <PlaceSignature contract={contract} form={form} />
    </>
  );
};

export default Content202301Sprava;
